import { PlayerConfig } from "ATVWebPlayer"

export const PLAYER_ELEMENT_ID = 'dv-web-player'

export const getPlayerElement = () => {
  let el = document.getElementById(PLAYER_ELEMENT_ID)

  if (el) {
    return el
  }

  el = document.createElement('div')
  el.setAttribute('id', PLAYER_ELEMENT_ID)
  document.body.appendChild(el)
  return el
}

const pageTypeToClientId = {
  Detail: 'f22dbddb-ef2c-48c5-8876-bed0d47594fd',
  DetailAndroid: '898eb3b8-96c0-4c6b-baa3-2d253860be8c',
  DetailAndroidMShop: '98d383c3-632a-4872-8ef8-7cc10d033066',
  Browse: '9ee9ba9b-f89c-41bb-8aa0-4db6e7f24cad',
  AIVWatchlist: '8e377055-28b0-4475-a3e7-f909ebcad6f1',
  YourVideoLibrary: '1e2f7321-aba1-4bd3-bdfc-a63777d869af',
  SPA: '933adc82-54c5-4fe0-9273-f1e188456161',
  PersonPage: '41e7965c-89b8-4967-bdd3-74e2a8f06636',
  ChannelsSubscription: '66d54d28-d754-4b11-b74d-427a03909d93',
  Following: '74392e3c-4c00-479e-90c8-f4d42aae8705'
}

export type PageType = 'Detail' | 'DetailAndroid' | 'DetailAndroidMShop' | 'Browse' | 'AIVWatchlist' | 'YourVideoLibrary' | 'SPA' | 'PersonPage' | 'ChannelsSubscription' | 'Following'

export const getClientIdByPageType = (pageType: PageType) => pageTypeToClientId[pageType]

type CustomPlayerInterationArgs = { pageType: PageType }
export type PlayerConfigData = Pick<PlayerConfig, Exclude<keyof PlayerConfig, 'domElement' | 'clientId' | 'deviceId'>> & CustomPlayerInterationArgs
export const getPlayerConfig = (playerConfigData: PlayerConfigData) => {
  const {
    marketplaceId,
    sessionId,
    playerBeta,
    customerId,
    locale,
    pageType
  } = playerConfigData

  const playerConfig = {
    marketplaceId,
    sessionId,
    playerBeta,
    customerId,
    locale,
    domElement: getPlayerElement(),
    clientId: getClientIdByPageType(pageType)
  }

  // Make sure that we don't use any undefined values.
  // The Player strips out undefined values from the config: https://code.amazon.com/packages/ATVWebPlayer/blobs/838ef25e9ab7a3d0bb7c1d6433bbc852d90ee219/--/src/Modules/DelegatingWebPlayer/extend.ts#L182
  // and when it's called again it fails to match the config even if the exact same object was passed: https://code.amazon.com/packages/ATVWebPlayer/blobs/eb2c43e6a107ef30f9dbcf35e53ebbcebe79d331/--/src/Modules/StatelessWebPlayer/StatelessWebPlayer.ts#L308
  Object.entries(playerConfig).forEach(([key, value] ) => {
    if (value === undefined) {
      delete playerConfig[key as keyof typeof playerConfig]
    }
  })

  return playerConfig as PlayerConfig
}